export default {
  header: 'Novos pedidos pausados',
  text: 'Toque em qualquer lugar para restaurar',
};
